import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { PagingDto } from "../../users/userslisting/dto/paging.dto";
import { IGetTemplateListItem } from "../templates.service";
import { AbstractTemplateListingComponent } from "../template-listing/abstract-template-listing.component";

@Component({
  selector: 'app-template-table',
  templateUrl: './template-table.component.html',
  encapsulation: ViewEncapsulation.None
})
export class TemplateTableComponent extends AbstractTemplateListingComponent {
  @Input() templateListing: IGetTemplateListItem[] = [];
  @Input() loading: boolean = false;
  @Input() pagination: PagingDto;
  @Input() page: number;
  @Output() pageChange = new EventEmitter<number>();


  override onPageChange(page: number): void {
    this.pageChange.emit(page);
  }
}
